<bl-modal-content #content
  [title]="headerTitle">
  <div body class="main-body">
    <table class="table table-bordered" border="2">
      <tr class="header second">
        <td class="title" colspan="2">コンタクトアラート通知条件を設定してください。</td>
      </tr>
      <tr>
        <th class="header-width">
          <span>アラート機能</span>
        </th>
        <td>
          <div>
            <bl-radio-group
              [(value)]="contactAlertSettingEx.alertFunctionUseDiv"
              [items]="useDivItems"
              [groupType]="'inline'"
            ></bl-radio-group>
          </div>
        </td>
      </tr>
      <tr>
        <th class="header-width">
          <span>実施内容</span>
        </th>
        <td>
          <div class="item_check_group_div">
            <bl-checkbox-group
              [values]="contactAlertSettingEx.contactCheckDivList"
              [items]="contactCheckDivArray"
              [option]="{'labelProperty': 'name','valueProperty': 'code'}"
              [groupType]="'inline'"
              [disabled]="!isAlertFunctionUse || isSelectIndividually"
              (changeEvent)="onChangeContactCheckDivArray($event)"
            ></bl-checkbox-group>
          </div>
          <div class="item_check_div">
            <div>
              <bl-checkbox
                [label]="'実施内容ごとに選択する'"
                [checked]="isSelectIndividually"
                [disabled]="!isAlertFunctionUse || isSelectContactCheckDivArray"
                (changeEvent)="onChangeIsSelectIndividually($event.target.checked)"
              ></bl-checkbox>
            </div>
            <div class="multi-select_length">
              <bl-multi-select
                [values]="contactAlertSettingEx.contactExecuteItemCodeList"
                [items]="contactImplDivArray"
                [option]="{labelProperty: 'name', valueProperty: 'code'}"
                [disabled]="!isAlertFunctionUse || !isSelectIndividually"
                (changeEvent)="onChangeContactImplDiv($event)"
              ></bl-multi-select>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <th class="header-width">
          <span>対象期間(実施予定日)</span>
          <span class="label-tag-required"></span>
        </th>
        <td>
          <div class="item_check_div">
            <div class="apply_select_fst">
              <!-- 適用開始期間基準区分 -->
              <bl-select
                [(value)]="contactAlertSettingEx.applyStartPeriodCriteriaDiv"
                [items]="applyPeriodCriteriaDivItems"
                [disabled]="!isAlertFunctionUse"
              ></bl-select>
            </div>
            <div class="apply_number_length">
              <bl-number-input
                [(value)]="contactAlertSettingEx.applyStartNum"
                [option]="{ minus: false, min: 0, max: 99 }"
                [disabled]="!isAlertFunctionUse || isApplyStartPeriodToday"
              ></bl-number-input>
            </div>
            <div class="apply_select_lst">
              <!-- 月週日区分 -->
              <bl-select
                [(value)]="contactAlertSettingEx.monthWeekDayDiv"
                [items]="monthWeekDayDivItems"
                [disabled]="!isAlertFunctionUse || isApplyStartPeriodToday"
              ></bl-select>
            </div>
            <span class="from_to">～</span>
            <div class="apply_select_fst">
              <!-- 適用終了期間基準区分 -->
              <bl-select
                [(value)]="contactAlertSettingEx.applyEndPeriodCriteriaDiv"
                [items]="applyPeriodCriteriaDivItems"
                [disabled]="!isAlertFunctionUse"
              ></bl-select>
            </div>
            <div class="apply_number_length">
              <bl-number-input
                [(value)]="contactAlertSettingEx.applyEndNum"
                [option]="{ minus: false, min: 0, max: 99 }"
                [disabled]="!isAlertFunctionUse || isApplyEndPeriodToday"
              ></bl-number-input>
            </div>
            <div class="apply_select_lst">
              <!-- 月週日区分 -->
              <bl-select
                [(value)]="contactAlertSettingEx.monthWeekDayDiv"
                [items]="monthWeekDayDivItems"
                [disabled]="!isAlertFunctionUse || isApplyEndPeriodToday"
              ></bl-select>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <th class="header-width">
          <span>担当者</span>
        </th>
        <td>
          <div class="item_check_div">
            <div>
              <bl-checkbox
                [checked]="contactAlertSettingEx.alertPicUseDiv"
                [label]="'ログイン担当者を使用する'"
                [disabled]="!isAlertFunctionUse"
                (changeEvent)="onChangeAlertPicUseDiv($event.target.checked)"
              ></bl-checkbox>
            </div>
            <div class="input-group form-size--l">
              <bl-text-input
                [(value)]="contactAlertSettingEx.alertPicName"
                [option]="{ maxLength: 60 }"
                [disabled]="!isAlertFunctionUse || contactAlertSettingEx.alertPicUseDiv"
                [placeholder]="'右のガイドからお選びください'"
                (changeEvent)="onChangeEmployee($event)"
              ></bl-text-input>
              <span class="input-group-btn">
                <button #employeeGuideButton
                  class="btn btn-default" type="button"
                  [disabled]="!isAlertFunctionUse || contactAlertSettingEx.alertPicUseDiv"
                  (click)="onClickEmployeeGuide(employeeGuideButton)">
                  <span class="icon-icon_guide glyphicon"></span>
                </button>
              </span>
            </div>
          </div>
        </td>
      </tr>
      <tr>
        <th>
          <span>適用開始日</span>
          <span class="label-tag-required"></span>
        </th>
        <td>
          <div class="half_length-date">
            <bl-date
              [(value)]="contactAlertSettingEx.applyStartDate"
              [defaultEraType]="JapanEraType.Reiwa"
              [viewEraTypeFrom]="JapanEraType.Heisei"
              [disabled]="!isAlertFunctionUse"
            ></bl-date>
          </div>
        </td>
      </tr>
    </table>
  </div>
</bl-modal-content>



// WEBPACK FOOTER //
// ./src/app/feature/contact-alert-setting/contact-alert-setting-modal.component.html